import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Menu from "@/pages/Menu";
import MyOrders from "@/pages/MyOrders";
import PreparatoreDashboard from "@/pages/PreparatoreDashboard";
import DishForm from "@/pages/DishForm";
import Admin from "@/pages/Admin";
import TelegramLink from "@/pages/TelegramLink";
import RecurringTemplates from "@/pages/RecurringTemplates";
import Info from "@/pages/Info";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Guide from "@/pages/Guide";
import Contact from "@/pages/Contact";
import SuperAdmin from "@/pages/SuperAdmin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Legal from "@/pages/Legal";

// Hoisted role arrays — referenced by ProtectedRoute. Defined at module scope so
// React doesn't see a new array reference on every App render.
const ROLES_PREPARATORE = ["preparatore", "admin", "superadmin"];
const ROLES_ADMIN = ["admin", "superadmin"];
const ROLES_SUPERADMIN = ["superadmin"];

function Shell({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/info" element={<Info />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/guida" element={<Guide />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="/legale" element={<Legal />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/menu" element={<ProtectedRoute><Shell><Menu /></Shell></ProtectedRoute>} />
            <Route path="/le-mie-prenotazioni" element={<ProtectedRoute><Shell><MyOrders /></Shell></ProtectedRoute>} />
            <Route path="/telegram" element={<ProtectedRoute><Shell><TelegramLink /></Shell></ProtectedRoute>} />

            <Route path="/preparatore" element={
              <ProtectedRoute roles={ROLES_PREPARATORE}>
                <Shell><PreparatoreDashboard /></Shell>
              </ProtectedRoute>
            } />
            <Route path="/preparatore/ricorrenti" element={
              <ProtectedRoute roles={ROLES_PREPARATORE}>
                <Shell><RecurringTemplates /></Shell>
              </ProtectedRoute>
            } />
            <Route path="/preparatore/piatti/nuovo" element={
              <ProtectedRoute roles={ROLES_PREPARATORE}>
                <Shell><DishForm /></Shell>
              </ProtectedRoute>
            } />
            <Route path="/preparatore/piatti/:id/modifica" element={
              <ProtectedRoute roles={ROLES_PREPARATORE}>
                <Shell><DishForm /></Shell>
              </ProtectedRoute>
            } />

            <Route path="/admin" element={
              <ProtectedRoute roles={ROLES_ADMIN}>
                <Shell><Admin /></Shell>
              </ProtectedRoute>
            } />
            <Route path="/super-admin" element={
              <ProtectedRoute roles={ROLES_SUPERADMIN}>
                <Shell><SuperAdmin /></Shell>
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
